export type RazaEventVenueSource = "hall" | "manual" | "its" | "none";

export type RazaEventHallBookingVenueLine = {
  hall?: { venue?: string | null } | null;
};

export type ResolveRazaEventVenueAddressInput = {
  storedAddress?: string | null;
  hallBookings?: RazaEventHallBookingVenueLine[] | null;
  itsAddress?: string | null;
};

export type ResolvedRazaEventVenueAddress = {
  value: string;
  source: RazaEventVenueSource;
};

function trimStr(v: unknown): string {
  if (v == null) return "";
  return String(v).trim();
}

function collectUniqueHallVenues(
  hallBookings: RazaEventHallBookingVenueLine[] | null | undefined
): string[] {
  return [
    ...new Set(
      (hallBookings ?? []).map((hb) => trimStr(hb.hall?.venue)).filter((venue) => venue.length > 0)
    ),
  ];
}

/** Effective venue: linked hall venue(s) → stored override → ITS host address. */
export function resolveRazaEventVenueAddress(
  input: ResolveRazaEventVenueAddressInput
): ResolvedRazaEventVenueAddress {
  const hallVenues = collectUniqueHallVenues(input.hallBookings);
  if (hallVenues.length > 0) {
    return { value: hallVenues.join("; "), source: "hall" };
  }

  const stored = trimStr(input.storedAddress);
  if (stored.length > 0) {
    return { value: stored, source: "manual" };
  }

  const its = trimStr(input.itsAddress);
  if (its.length > 0) {
    return { value: its, source: "its" };
  }

  return { value: "", source: "none" };
}
